import { Component, EventEmitter, Input, OnInit, Output, TemplateRef, ViewChild } from "@angular/core";
import { FormControl } from "@angular/forms";
import { Store } from "@ngrx/store";
import { ToasterService } from "angular2-toaster";
import * as _ from "lodash";
import swal from "sweetalert2";
import * as fromRootStore from "../../../reducers";
import { FinyearService, SalesOrderService, WorkOrderService } from "../../../services/index";
import { WhWorkOrderService } from "../../../services/whWorkOrder.service";

@Component({
    selector: "cdcEstimation",
    templateUrl: "./cdcEstimation.html",
})
export class cdcEstimation implements OnInit {
    @Input("tabTitle") title: string;
    @Input("tabID") tabID: string;
    @Input() active = false;
    @Input() dataContext;
    @Output() tabUpdateEvent = new EventEmitter();

    isLoadMask: Promise<any>;
    list: any[];
    selectedDlrMapList: any[];
    loadingIndicator: boolean = true;
    reorderable: boolean = true;
    filter: any;

    page = {
        limit: 25,
        count: 0,
        offset: 0,
        orderBy: "order_from",
        orderDir: "asc",
    };

    @ViewChild("snoTemplate") snoTemplate: TemplateRef<any>;
    @ViewChild("nameTemplate") nameTemplate: TemplateRef<any>;
    @ViewChild("addrTemplate") addrTemplate: TemplateRef<any>;
    @ViewChild("editDeleteTemplate") editDeleteTemplate: TemplateRef<any>;
    @ViewChild("filterPanel") filterPanel;
    @ViewChild("partyDataTable") partyDataTable;

    columns = [];
    toggleCol = [];
    selected = [];
    filterExpand = false;

    agentList$ = [];
    companyInfo: any = [];
    finyearCtrl: FormControl = new FormControl();
    finyearList = [];
    constructor(
        private finyearService: FinyearService,
        public store: Store<fromRootStore.State>,
        private Woservice: WorkOrderService,
        private whWorkOrderService: WhWorkOrderService,
        public toasterService: ToasterService,
        private Salesservice: SalesOrderService,
    ) {
        this.filter = {
            party: "",
            user: '',
            status: '',
            date: '',
        };
    }

    ngOnInit(): void {
        this.columns = [
            {
                name: "S.No",
                prop: "sno",
                minWidth: 80,
                maxWidth: 80,
                width: 80,
                headerClass: "text-center",
                sortable: false,
                cellTemplate: this.snoTemplate,
                toggle: true,
                cellClass: "text-center",
            },
            {
                name: "CDC Est No",
                prop: "cdc_est_id",
                minWidth: 100,
                maxWidth: 100,
                width: 100,
                cellClass: 'text-right'
            },
            {
                name: "Date",
                prop: "date",
                minWidth: 200,
                maxWidth: 200,
                width: 200,
            },
            {
                name: "Party",
                prop: "party_name",
                minWidth: 350,
                maxWidth: 350,
                width: 350,
            },
            {
                name: "WO Ass No",
                prop: "wh_wo_ass_id",
                minWidth: 100,
                maxWidth: 100,
                width: 100,
                cellClass: 'text-right'
            },
            {
                name: "User",
                prop: "username",
                minWidth: 200,
                maxWidth: 200,
                width: 200,
            },
            {
                name: "Est Qty",
                prop: "estimated_items",
                minWidth: 150,
                maxWidth: 150,
                width: 150,
                cellClass: 'text-right'
            },
            {
                name: "Cancelled Qty",
                prop: "cancelled_items",
                minWidth: 150,
                maxWidth: 150,
                width: 150,
                cellClass: 'text-right'
            },
            {
                name: "Status",
                prop: "status",
                minWidth: 150,
                maxWidth: 150,
                width: 150
            },
            { name: 'Action', prop: 'sno', minWidth: 100, maxWidth: 100, width: 100, sortable: false, cellTemplate: this.editDeleteTemplate }
        ];

        this.toggleCol = Object.assign({}, this.columns);

        this.pageCallback({ offset: 0 });
    }

    onOpenedFilter(): void {
        setTimeout(function () {
            $("#filterpartyName").focus();
        }, 100);
    }

    onChangePageSize(limit) {
        this.page.limit = limit;
        this.getList();
    }

    onColumnToggle(colToShow) {
        this.columns = colToShow;
    }

    /**
     * Called whenever the user changes page
     */
    pageCallback(pageInfo: {
        count?: number;
        pageSize?: number;
        limit?: number;
        offset?: number;
    }) {
        this.page.offset = pageInfo.offset;
        this.getList();
    }

    /**
     * Called whenever the user changes the sort order
     */
    sortCallback(sortInfo: {
        sorts: { dir: string; prop: string }[];
        column: {};
        prevValue: string;
        newValue: string;
    }) {
        // there will always be one "sort" object if "sortType" is set to "single"
        this.page.orderDir = sortInfo.sorts[0].dir;
        this.page.orderBy = sortInfo.sorts[0].prop;
        this.getList();
    }

    getList(): void {
        let params = {
            start: `${this.page.offset * (this.page.limit + 0)}`,
            limit: `${this.page.limit}`,
            page: "1",
            orderColumn: `${this.page.orderBy}`,
            orderDir: `${this.page.orderDir}`,
            ...this.filter
        };
        let that = this;
        //this.store.dispatch(new commonActions.LoadAllParty(params));
        this.isLoadMask = this.whWorkOrderService
            .getCdcEstimationList(params)
            .then(function (res: any) {
                that.loadingIndicator = false;
                that.page.count = res.total;
                that.list = res.data;
                console.log("list :: ", that.list, res);
            });
    }

    clearFilter(): void {
        this.filter = {
            party: "",
            user: '',
            status: '',
            date: '',
        };
        this.applyFilter();
    }

    applyFilter(): void {
        // this.filterPanel.close();
        this.getList();
    }

    goToAddEdit(mode: 'ADD' | 'EDIT', row: any): void {
        const listUpdateEvent = new EventEmitter();
        listUpdateEvent.subscribe(() => {
            this.getList();
        });

        row.tabevent = listUpdateEvent;

        const tabLabel = `${mode} CDC ESTIMATION`;

        const tabObj = {
            action: "NewTab",
            params: {
                tabName: tabLabel,
                title: tabLabel,
                tabParent: "BAGGIING & RACKING PROCESS_TRANSACTION",
                mode,
                data: row,
                name: tabLabel,
            },
        };

        this.tabUpdateEvent.emit(tabObj);
    }

    onSelect({ selected }, ind) {

        this.selected.splice(0, this.selected.length);
        this.selected.push(...selected);
    }

    deleteRackDetails(row): void {

        let params = {
            requestId: row.id
        };
        let that = this;
        swal({
            title: "Are you sure to delete",
            type: "warning",
            showCancelButton: true,
            confirmButtonText: "Yes, delete it!",
            cancelButtonText: "No, keep it",
        }).then(
            function () {
                that.isLoadMask = that.Woservice
                    .deleteRackAllocateDetails(params)
                    .then(function (res: any) {
                        that.loadingIndicator = false;

                        let errtype = "success",
                            errmsg = res.message;
                        if (!res.success) {
                            errtype = "error";
                        }
                        else {
                            that.getList();
                        }
                        that.toasterService.pop({
                            bodyOutputType: 1,
                            type: errtype,
                            title: errtype.toUpperCase(),
                            body: errmsg,
                        });
                    });
            },
            function (dismiss) {
                // dismiss can be 'overlay', 'cancel', 'close', 'esc', 'timer'
                /*if (dismiss === 'cancel') {
                      swal(
                        'Cancelled',
                        'Your imaginary file is safe :)',
                        'error'
                      )
                    }*/
            }
        );
    }

    convertToCdc(row) {
        const cdc_est_id = row.cdc_est_id;
        let that = this;
        swal({
            title: "Are you sure to convert to cdc",
            type: "warning",
            showCancelButton: true,
            confirmButtonText: "Yes, convert it!",
            cancelButtonText: "No, keep it",
        }).then(
            function () {
                let params = {
                    cdc_est_id: cdc_est_id
                };
                that.isLoadMask = that.whWorkOrderService
                    .getCdcEstimationDetails(params)
                    .then(function (res: any) {
                        that.loadingIndicator = false;

                        if (res.success) {
                            const saveCdcParams = JSON.parse(JSON.stringify(res.data));
                            saveCdcParams.cdc_est_id = cdc_est_id
                            saveCdcParams['dcinvoice'] = JSON.stringify(saveCdcParams['dcinvoice']);
                            that.Salesservice
                                .Savecounterdcentry(saveCdcParams)
                                .then(function (saveCdcRes: any) {

                                    if (saveCdcRes.success) {
                                        that.whWorkOrderService.updateCdcEstimationStatus({ cdc_est_id, status: 'CONVERTED' }).then(function (updateCdcRes: any) {
                                            if (updateCdcRes.success) {
                                                that.toasterService.pop({
                                                    bodyOutputType: 1,
                                                    type: 'success',
                                                    title: 'SUCCESS',
                                                    body: 'Converted successfully'
                                                });
                                                that.getList();
                                            } else {
                                                that.toasterService.pop({
                                                    bodyOutputType: 1,
                                                    type: 'error',
                                                    title: 'ERROR',
                                                    body: 'Error while updating cdc estimation status'
                                                });
                                            }
                                        })
                                    } else {
                                        that.toasterService.pop({
                                            bodyOutputType: 1,
                                            type: 'error',
                                            title: 'ERROR',
                                            body: 'Error while creating counter dc'
                                        });
                                    }

                                })
                        } else {
                            that.toasterService.pop({
                                bodyOutputType: 1,
                                type: 'error',
                                title: 'ERROR',
                                body: 'Error while getting cdc estimation data'
                            });
                        }

                    });
            }
        )
    }
}


// WEBPACK FOOTER //
// /Users/afsarahamed/Documents/symatis/projects/hyatt-angularweb/src/app/components/phase1/CdcEstimation/cdcEstimation.ts